import React, { useState, useEffect } from "react";
import { Grid, Card } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./styles.css";
import { styles } from "./styles";
import {
  formatCurrency,
  formatterUSD,
} from "../../../commons/functions/generalFunctions";
import RedTag from "../components/RedTag/RedTag";
const ProductItem = (props) => {
  let { id, data, currencySelect } = props;
  const [currencyValue, SetCurrencyValue] = useState(0);

  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);

  useEffect(() => {
    if (data.images) {
      data.images.sort((before, next) => {
        let beforeParse = JSON.parse(before);
        let nextParse = JSON.parse(next);
        return beforeParse.position - nextParse.position;
      });
    } else {
      let obj = {
        //Imagen por default
        url:
          "https://firebasestorage.googleapis.com/v0/b/floristeria-honduras.appspot.com/o/brand%2Flogo192.png?alt=media&token=d8b2e987-ba39-4e17-bdd2-2b8d174b80d7",
      };
      data.images = [JSON.stringify(obj)];
    }
  }, [data]);

  return (
    <>
      {props.data ? (
        !props.data.hidden ? (
          <Grid.Column
            className="col-12 col-lg-3 col-md-4 col-sm-6 p-4"
            style={styles.gridColum}
          >
            <Link
              to={`/product/${id}`}
              className="text-decoration-none text-dark"
            >
              {
                data.images && (
                  // data.images.map((image, key) => {
                  //   if (JSON.parse(image).position === "1") {
                  // return (
                  <Card
                    className="product-item-img"
                    //key={key}
                    style={{
                      backgroundImage: `url(${JSON.parse(data.images[0]).url})`,
                      display: "flex",
                      backgroundSize: "cover",
                      objectFit: "cover",
                      backgroundPosition: "center",
                      height: 370,
                      justifyContent: "flex-end",
                    }}
                  >
                    <Card.Content style={styles.cardContent}>
                      {!data.available ? <RedTag message="Agotado" /> : null}
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          height: 330,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      />
                      <div style={styles.divContent}>
                        <Card.Header
                          style={styles.cardHeader}
                        >{`${data.code} ${data.name}`}</Card.Header>
                        <Card.Meta>
                          <span className="date" style={styles.spam}>
                            {currencySelect.loading
                              ? "Cargando..."
                              : currencyValue === 0
                              ? formatCurrency(Math.ceil(data.price))
                              : formatterUSD.format(
                                  Math.ceil(
                                    data.price / currencyValue.data.value
                                  ) - 0.01
                                )}
                          </span>
                        </Card.Meta>
                        {/* <Card.Description>{data.description}</Card.Description> */}
                      </div>
                    </Card.Content>
                  </Card>
                )
                // );
                //   }
                //   return null;
                // })
              }
            </Link>
          </Grid.Column>
        ) : null
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    currencySelect: state.currencySelect,
  };
};

export default connect(mapStateToProps)(ProductItem);
